import { AxiosResponse } from 'axios';
import cacheableRequest from '../../../services/cacheableRequest';
import { User } from '../domain/User';
import { UserResponse } from '../type/userResponse';
import { transformSessionUser } from '../utils/transformSessionUser';
import { getStoredUser, persistStoredUser } from '../utils/userStorage';
import { forgetJwt, getJwt, keepJwt, validateJwt } from '../../../services/jwt';

function hasValidJwt(): boolean {
  return Boolean(getJwt());
}

let pendingSessionPromise: Promise<User | undefined> | null = null;

export function clearSessionUserCache(): void {
  pendingSessionPromise = null;
}

export function getSessionUser(): Promise<User | undefined> {
  if (!hasValidJwt()) {
    return Promise.resolve(undefined);
  }

  const storedUser = getStoredUser();
  if (storedUser) {
    return Promise.resolve(storedUser);
  }

  if (pendingSessionPromise) {
    return pendingSessionPromise;
  }

  pendingSessionPromise = cacheableRequest('/v1/security')
    .then(({ headers, data }: AxiosResponse<UserResponse>) => {
      const headerToken = headers['set-authorization'];

      if (!headerToken) {
        forgetJwt();
        return undefined;
      }

      if (!validateJwt(headerToken)) {
        forgetJwt();
        return undefined;
      }

      keepJwt(headerToken);
      const redirectURL = sessionStorage.getItem('redirectUrl') || undefined;
      const user = transformSessionUser(data, redirectURL);
      persistStoredUser(user);
      return user;
    })
    .catch(() => undefined)
    .finally(() => {
      pendingSessionPromise = null;
    });

  return pendingSessionPromise as Promise<User | undefined>;
}
